// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__5dGX3","rounded":"Tag_rounded__pd2fC"};